/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountAssetAllocation,
  AssetAllocationCategoryType,
  AssetAllocationOverrideRequest,
  AssetAllocationPage,
  Filter,
  HTTPValidationError,
  MixedAssetAllocationRequest,
  SecurityAssetAllocation,
  SecurityWeight,
} from '../models/index';
import {
    AccountAssetAllocationFromJSON,
    AccountAssetAllocationToJSON,
    AssetAllocationCategoryTypeFromJSON,
    AssetAllocationCategoryTypeToJSON,
    AssetAllocationOverrideRequestFromJSON,
    AssetAllocationOverrideRequestToJSON,
    AssetAllocationPageFromJSON,
    AssetAllocationPageToJSON,
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    MixedAssetAllocationRequestFromJSON,
    MixedAssetAllocationRequestToJSON,
    SecurityAssetAllocationFromJSON,
    SecurityAssetAllocationToJSON,
    SecurityWeightFromJSON,
    SecurityWeightToJSON,
} from '../models/index';

export interface DeleteAssetAllocationOverrideRequest {
    sId: string;
}

export interface GetAllocationAssetAllocationRequest {
    allocationGuid: string;
    categoryType: AssetAllocationCategoryType;
}

export interface GetAssetAllocationsRequest {
    pageIndex: number;
    pageSize: number;
    sortLabel?: string;
    sortDesc?: boolean;
    hasUncategorizedExposure?: boolean;
    hasActiveOverride?: boolean;
    hasHoldings?: boolean;
    filter?: Array<Filter>;
}

export interface PostAccountAssetAllocationRequest {
    requestBody: Array<string>;
}

export interface PostAccountAssetAllocationByAccountRequest {
    requestBody: Array<string>;
    categoryType?: AssetAllocationCategoryType;
}

export interface PostAccountAssetAllocationChartRequest {
    categoryType: AssetAllocationCategoryType;
    requestBody: Array<string>;
}

export interface PostMixedAssetAllocationRequest {
    categoryType: AssetAllocationCategoryType;
    mixedAssetAllocationRequest: MixedAssetAllocationRequest;
}

export interface PostSecurityAssetAllocationRequest {
    categoryType: AssetAllocationCategoryType;
    securityWeight: Array<SecurityWeight>;
}

export interface SetAssetAllocationOverrideRequest {
    sId: string;
    assetAllocationOverrideRequest: AssetAllocationOverrideRequest;
}

/**
 * 
 */
export class AssetAllocationApi extends runtime.BaseAPI {

    /**
     * Delete all asset allocation overrides for a security.
     */
    async deleteAssetAllocationOverrideRaw(requestParameters: DeleteAssetAllocationOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sId === null || requestParameters.sId === undefined) {
            throw new runtime.RequiredError('sId','Required parameter requestParameters.sId was null or undefined when calling deleteAssetAllocationOverride.');
        }

        const queryParameters: any = {};

        if (requestParameters.sId !== undefined) {
            queryParameters['s_id'] = requestParameters.sId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/override`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all asset allocation overrides for a security.
     */
    async deleteAssetAllocationOverride(requestParameters: DeleteAssetAllocationOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetAllocationOverrideRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve aggregated asset allocations for an allocation by resolving its strategy weights from the portfolio service.
     */
    async getAllocationAssetAllocationRaw(requestParameters: GetAllocationAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SecurityAssetAllocation>>> {
        if (requestParameters.allocationGuid === null || requestParameters.allocationGuid === undefined) {
            throw new runtime.RequiredError('allocationGuid','Required parameter requestParameters.allocationGuid was null or undefined when calling getAllocationAssetAllocation.');
        }

        if (requestParameters.categoryType === null || requestParameters.categoryType === undefined) {
            throw new runtime.RequiredError('categoryType','Required parameter requestParameters.categoryType was null or undefined when calling getAllocationAssetAllocation.');
        }

        const queryParameters: any = {};

        if (requestParameters.allocationGuid !== undefined) {
            queryParameters['allocation_guid'] = requestParameters.allocationGuid;
        }

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/allocation-aggregation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SecurityAssetAllocationFromJSON));
    }

    /**
     * Retrieve aggregated asset allocations for an allocation by resolving its strategy weights from the portfolio service.
     */
    async getAllocationAssetAllocation(requestParameters: GetAllocationAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SecurityAssetAllocation>> {
        const response = await this.getAllocationAssetAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve asset allocations with the specified filters.
     */
    async getAssetAllocationsRaw(requestParameters: GetAssetAllocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetAllocationPage>> {
        if (requestParameters.pageIndex === null || requestParameters.pageIndex === undefined) {
            throw new runtime.RequiredError('pageIndex','Required parameter requestParameters.pageIndex was null or undefined when calling getAssetAllocations.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling getAssetAllocations.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        if (requestParameters.hasUncategorizedExposure !== undefined) {
            queryParameters['has_uncategorized_exposure'] = requestParameters.hasUncategorizedExposure;
        }

        if (requestParameters.hasActiveOverride !== undefined) {
            queryParameters['has_active_override'] = requestParameters.hasActiveOverride;
        }

        if (requestParameters.hasHoldings !== undefined) {
            queryParameters['has_holdings'] = requestParameters.hasHoldings;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetAllocationPageFromJSON(jsonValue));
    }

    /**
     * Retrieve asset allocations with the specified filters.
     */
    async getAssetAllocations(requestParameters: GetAssetAllocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetAllocationPage> {
        const response = await this.getAssetAllocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update asset allocation cache
     */
    async invalidateAssetAllocationCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update asset allocation cache
     */
    async invalidateAssetAllocationCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateAssetAllocationCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve asset allocations summed across all positions for a single portfolio.
     */
    async postAccountAssetAllocationRaw(requestParameters: PostAccountAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountAssetAllocation>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling postAccountAssetAllocation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/account-aggregation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountAssetAllocationFromJSON));
    }

    /**
     * Retrieve asset allocations summed across all positions for a single portfolio.
     */
    async postAccountAssetAllocation(requestParameters: PostAccountAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountAssetAllocation>> {
        const response = await this.postAccountAssetAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve asset allocations summed across all positions of each account separately, keyed by the requested broker account id (broker_id_a_c). An account without cached positions is returned with an empty list.
     */
    async postAccountAssetAllocationByAccountRaw(requestParameters: PostAccountAssetAllocationByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<AccountAssetAllocation>; }>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling postAccountAssetAllocationByAccount.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/account-aggregation-by-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve asset allocations summed across all positions of each account separately, keyed by the requested broker account id (broker_id_a_c). An account without cached positions is returned with an empty list.
     */
    async postAccountAssetAllocationByAccount(requestParameters: PostAccountAssetAllocationByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<AccountAssetAllocation>; }> {
        const response = await this.postAccountAssetAllocationByAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve asset allocations summed across all positions for a single portfolio.
     */
    async postAccountAssetAllocationChartRaw(requestParameters: PostAccountAssetAllocationChartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountAssetAllocation>>> {
        if (requestParameters.categoryType === null || requestParameters.categoryType === undefined) {
            throw new runtime.RequiredError('categoryType','Required parameter requestParameters.categoryType was null or undefined when calling postAccountAssetAllocationChart.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling postAccountAssetAllocationChart.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/account-aggregation-chart`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountAssetAllocationFromJSON));
    }

    /**
     * Retrieve asset allocations summed across all positions for a single portfolio.
     */
    async postAccountAssetAllocationChart(requestParameters: PostAccountAssetAllocationChartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountAssetAllocation>> {
        const response = await this.postAccountAssetAllocationChartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve aggregated asset allocations for a mix of weighted strategies and weighted securities. Strategy guids are resolved through the portfolio service; securities can be provided directly for strategies that do not list their securities.
     */
    async postMixedAssetAllocationRaw(requestParameters: PostMixedAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SecurityAssetAllocation>>> {
        if (requestParameters.categoryType === null || requestParameters.categoryType === undefined) {
            throw new runtime.RequiredError('categoryType','Required parameter requestParameters.categoryType was null or undefined when calling postMixedAssetAllocation.');
        }

        if (requestParameters.mixedAssetAllocationRequest === null || requestParameters.mixedAssetAllocationRequest === undefined) {
            throw new runtime.RequiredError('mixedAssetAllocationRequest','Required parameter requestParameters.mixedAssetAllocationRequest was null or undefined when calling postMixedAssetAllocation.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/mixed-aggregation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MixedAssetAllocationRequestToJSON(requestParameters.mixedAssetAllocationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SecurityAssetAllocationFromJSON));
    }

    /**
     * Retrieve aggregated asset allocations for a mix of weighted strategies and weighted securities. Strategy guids are resolved through the portfolio service; securities can be provided directly for strategies that do not list their securities.
     */
    async postMixedAssetAllocation(requestParameters: PostMixedAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SecurityAssetAllocation>> {
        const response = await this.postMixedAssetAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve aggregated asset allocations for a list of securities and their respective weights.
     */
    async postSecurityAssetAllocationRaw(requestParameters: PostSecurityAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SecurityAssetAllocation>>> {
        if (requestParameters.categoryType === null || requestParameters.categoryType === undefined) {
            throw new runtime.RequiredError('categoryType','Required parameter requestParameters.categoryType was null or undefined when calling postSecurityAssetAllocation.');
        }

        if (requestParameters.securityWeight === null || requestParameters.securityWeight === undefined) {
            throw new runtime.RequiredError('securityWeight','Required parameter requestParameters.securityWeight was null or undefined when calling postSecurityAssetAllocation.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/security-aggregation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.securityWeight?.map(SecurityWeightToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SecurityAssetAllocationFromJSON));
    }

    /**
     * Retrieve aggregated asset allocations for a list of securities and their respective weights.
     */
    async postSecurityAssetAllocation(requestParameters: PostSecurityAssetAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SecurityAssetAllocation>> {
        const response = await this.postSecurityAssetAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set asset allocation overrides for a security. Replaces overrides for a given category type - the request should contain overrides for all categories of a category type.
     */
    async setAssetAllocationOverrideRaw(requestParameters: SetAssetAllocationOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sId === null || requestParameters.sId === undefined) {
            throw new runtime.RequiredError('sId','Required parameter requestParameters.sId was null or undefined when calling setAssetAllocationOverride.');
        }

        if (requestParameters.assetAllocationOverrideRequest === null || requestParameters.assetAllocationOverrideRequest === undefined) {
            throw new runtime.RequiredError('assetAllocationOverrideRequest','Required parameter requestParameters.assetAllocationOverrideRequest was null or undefined when calling setAssetAllocationOverride.');
        }

        const queryParameters: any = {};

        if (requestParameters.sId !== undefined) {
            queryParameters['s_id'] = requestParameters.sId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-allocation/override`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssetAllocationOverrideRequestToJSON(requestParameters.assetAllocationOverrideRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set asset allocation overrides for a security. Replaces overrides for a given category type - the request should contain overrides for all categories of a category type.
     */
    async setAssetAllocationOverride(requestParameters: SetAssetAllocationOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setAssetAllocationOverrideRaw(requestParameters, initOverrides);
    }

}
